const COOKIE_KEY = 'sirivannavari_cookie_consent';
const COOKIE_DOMAIN = '.sirivannavari.com';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 ปี

export const CONSENT_CHANGED_EVENT = 'cookie-consent-changed';

export type CookieConsent = 'all' | 'essential';

let memoryConsent: string | null = null;

export const getCookieConsent = (): string | null => {
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${COOKIE_KEY}=`));
  return match ? match.split('=')[1] : memoryConsent;
};

export const setCookieConsent = (value: CookieConsent) => {
  memoryConsent = value;
  document.cookie = `${COOKIE_KEY}=${value}; path=/; domain=${COOKIE_DOMAIN}; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
  window.dispatchEvent(new Event(CONSENT_CHANGED_EVENT));
};

export const hasPerformanceConsent = (): boolean => getCookieConsent() === 'all';
